const BASKET_ID_KEY = 'basket_id';
const CTA_CLICKED_JOURNEY = 'cta_clicked_journey';
const SUBMITTED_ADDRESS_PAGE_VALUES = 'addressPageSubmitted';
const COMPLETED_BASKET_ID_KEY = 'completed_basket_id';
const INSURANCE_WARNING_SEEN_KEY = 'insurance-warning-seen';
const APPOINTMENT_TOKEN = 'appointment-token';
const APPOINTMENT_ID = 'appointment-id';
const APPOINTMENT_USER_ID = 'appointment-user-id';
const APPOINTMENT_USER_TYPE = 'appointment-user-type';
const TUTORIAL_CONTROLS_SEEN_KEY = 'tutorial-session-seen';
const TUTORIAL_FEEDBACK_SEEN_KEY = 'tutorial-feedback-seen';
const CUSTOMER_REFERRAL_NUMBER = 'customer-referral-number';
const PARTNER_PORTAL = 'partner-portal';
const QUOTE = 'quote';
const QUOTE_SALES = 'quote-sales';
const HOSTED_ID_KEY = 'hosted_id';
const AUTO_JOIN = 'autoJoin';
const ATTRIBUTION_TOKEN = 'attribution_token';
const DISABLE_PARTNER_AUTO_LOGIN = 'disable-partner-auto-login';
const THANK_YOU_DETAILS_KEY = 'thank_you_details';
const SELECTED_SIMS_KEY = 'selected-sims';

export {
  BASKET_ID_KEY,
  CTA_CLICKED_JOURNEY,
  SUBMITTED_ADDRESS_PAGE_VALUES,
  COMPLETED_BASKET_ID_KEY,
  INSURANCE_WARNING_SEEN_KEY,
  APPOINTMENT_TOKEN,
  APPOINTMENT_ID,
  APPOINTMENT_USER_ID,
  APPOINTMENT_USER_TYPE,
  TUTORIAL_CONTROLS_SEEN_KEY,
  TUTORIAL_FEEDBACK_SEEN_KEY,
  CUSTOMER_REFERRAL_NUMBER,
  PARTNER_PORTAL,
  QUOTE,
  QUOTE_SALES,
  HOSTED_ID_KEY,
  AUTO_JOIN,
  ATTRIBUTION_TOKEN,
  DISABLE_PARTNER_AUTO_LOGIN,
  THANK_YOU_DETAILS_KEY,
  SELECTED_SIMS_KEY,
};
